import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LoadingSkeleton from '../components/LoadingSkeleton';
import { useAuth } from '../context/AuthContext';
import { apiCall } from '../services/api.service';

const OrderPage = () => {
  const { user, token } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchOrders = async () => {
      if (!user?.id || !token) return;

      try {
        const result = await apiCall('post', 'v1/orders/getUserOrders', { user_id: user.id }, token);
        if (result.success) {
          setOrders(result.data || []);
        } else {
          setError(result.message || 'Failed to load orders');
        }
      } catch (err) {
        console.error('Error fetching orders:', err);
        setError('An error occurred while loading orders');
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [user, token]);

  const getStatusBadge = (status) => {
    const statusMap = {
      'created': 'warning',
      'confirmed': 'info',
      'preparing': 'primary',
      'ready': 'success',
      'delivered': 'success',
      'cancelled': 'danger'
    };
    return statusMap[status] || 'secondary';
  };

  if (loading) {
    return (
      <>
        <Header />
        <main className="main__content_wrapper">
          <div className="container py-5">
            <div className="row">
              <div className="col-12">
                <div className="skeleton skeleton-text mb-4" style={{ height: '32px', width: '200px' }}></div>
                <LoadingSkeleton type="order" count={3} />
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <main className="main__content_wrapper">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <h1 className="mb-4">My Orders</h1>
              
              {error && (
                <div className="alert alert-danger">{error}</div>
              )}
              
              {orders.length === 0 && !error ? (
                <div className="text-center py-5">
                  <h3>No orders found</h3>
                  <p>You haven't placed any orders yet.</p>
                  <Link to="/shop" className="btn btn-primary">Start Shopping</Link>
                </div>
              ) : (
                <div className="row">
                  {orders.map((order) => (
                    <div key={order.id} className="col-12 mb-4">
                      <div className="card">
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <h5 className="card-title">Order #{order.id}</h5>
                              <p className="card-text mb-2">
                                <strong>Date:</strong> {new Date(order.date_time).toLocaleDateString()}<br/>
                                <strong>Total:</strong> ${order.grand_total}<br/>
                                <strong>Payment:</strong> {order.paid_method}
                              </p>
                              <span className={`badge bg-${getStatusBadge(order.status)}`}>
                                {order.status?.charAt(0).toUpperCase() + order.status?.slice(1)}
                              </span>
                            </div>
                            <div className="col-md-4 text-end">
                              <Link to={`/order/${order.id}`} className="btn btn-primary">
                                View Details
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default OrderPage;